export default "__VITE_ASSET__DinKaO43__"